module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projectDetail"
  }, [_c('mt-header', {
    attrs: {
      "title": '项目详情：' + _vm.project.title
    }
  }, [_c('mt-button', {
    attrs: {
      "slot": "left",
      "icon": "back"
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    },
    slot: "left"
  }, [_vm._v("返回")])], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "bg_img ",
    class: {
      'zhaomu': _vm.project.status == 4, 'close': _vm.project.status == 5, 'jinxing': _vm.project.status == 7, 'over': _vm.project.status == 8, 'hezuo': _vm.project.status == 6, 'pingjia': _vm.project.status == 9
    }
  }), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.project.title))]), _vm._v(" "), _c('span', {
    staticClass: "type"
  }, [_vm._v(_vm._s(_vm.project.projectChildTypeName))]), _vm._v(" "), _c('p', {
    staticClass: "time"
  }, [_vm._v(_vm._s(_vm.project.releaseTime))]), _vm._v(" "), _c('div', {
    staticClass: "cycle"
  }, [_c('div', {
    staticClass: "money"
  }, [_c('span', [_vm._v("项目预算")]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.project.prepriceName))])]), _vm._v(" "), _c('div', {
    staticClass: "time"
  }, [_c('span', [_vm._v("时间周期")]), _vm._v(" "), _c('p', [_c('span', [_vm._v(_vm._s(_vm.project.periodName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "skills"
  }, _vm._l((_vm.project.skillsList), function(skills, index) {
    return _c('span', {
      key: index
    }, [_vm._v(_vm._s(skills))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "path"
  }, [_c('p', [_c('icon', {
    attrs: {
      "name": "suitcase"
    }
  }), _vm._v(" " + _vm._s(_vm.project.industryName))], 1), _vm._v(" "), _c('p', [_c('icon', {
    attrs: {
      "name": "map-marker"
    }
  }), _vm._v(" " + _vm._s(_vm.project.cityName))], 1), _vm._v(" "), (_vm.project.enterType == 0) ? _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" 接单倾向  无")], 1) : (_vm.project.enterType == 1) ? _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" 接单倾向  个人")], 1) : _c('p', [_c('icon', {
    attrs: {
      "name": "cogs"
    }
  }), _vm._v(" 接单倾向  团队工作室")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "describe"
  }, [_c('p', [_vm._v("项目描述")]), _vm._v(" "), _c('pre', [_vm._v("         " + _vm._s(_vm.project.description) + "\n       ")])]), _vm._v(" "), _c('div', {
    staticClass: "img_describe"
  }, _vm._l((_vm.photoList), function(photoList, index) {
    return _c('img', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy",
        value: (photoList.fullPath),
        expression: "photoList.fullPath"
      }],
      key: index
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "recommend"
  }, [_c('p', [_vm._v("已推荐 " + _vm._s(_vm.project.countRecommender) + " 人")]), _vm._v(" "), (_vm.project.countRecommender != 0) ? _c('div', _vm._l((_vm.recommendExpertList), function(recommend, index) {
    return _c('span', {
      key: index
    }, [(recommend.photo) ? _c('img', {
      attrs: {
        "src": _vm.httpUrl + recommend.photo
      }
    }) : _vm._e(), _vm._v("\n             " + _vm._s(recommend.account.name) + "\n           ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "apply"
  }, [_c('p', [_vm._v("已申请 " + _vm._s(_vm.project.countOffer) + " 人")]), _vm._v(" "), (_vm.project.countOffer != 0) ? _c('div', _vm._l((_vm.applyExpertList), function(apply, index) {
    return _c('span', {
      key: index
    }, [(apply.photo) ? _c('img', {
      attrs: {
        "src": _vm.httpUrl + apply.photo
      }
    }) : _vm._e(), _vm._v("\n             " + _vm._s(apply.account.name) + "\n          ")])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "look"
  }, [_c('p', [_vm._v("已浏览 " + _vm._s(_vm.project.countVisit) + " 人")])])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "send_btn"
  }, [(_vm.project.status == 4 && _vm.applyflag) ? _c('span', {
    on: {
      "click": _vm.saveprojectoff
    }
  }, [_vm._v("发送申请意向")]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f3a915c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/projectDetail.vue
// module id = 1290
// module chunks = 1